import Icon from "./Icon";
import DOMPurify from "dompurify";
import iconMapping from "../icon-mapping.json";

function FlexList(props) {
  let outerClassName = (props.which && props.which === 'flats') ? props.className + " tw-grid tw-grid-cols-4 tw-grid-rows-auto":
    props.className + " tw-grid tw-grid-cols-3 md:tw-grid-cols-4 tw-grid-rows-auto";

  outerClassName += (props.gap === 'default') ? ' tw-gap-5' : ' tw-gap-x-2 tw-gap-y-8';
  let innerClassName = "md:tw-bg-gray-light md:tw-rounded-xl";
  if (props.size && props.size === "large")
    innerClassName += " md:tw-space-x-5 md:tw-text-center md:tw-flex-row tw-p-0 md:tw-p-5";

  let imageOuterClassName =
    props.size && props.size === "large"
      ? "md:tw-w-20 md:tw-h-20 md:tw-bg-white"
      : "md:tw-w-16 md:tw-h-16";
  let imageInnerClassName =
    props.size && props.size === "large"
      ? "md:tw-w-16 md:tw-h-16"
      : "md:tw-w-12 md:tw-h-12";

  let textClassName =
    props.size && props.size === "large"
      ? "md:tw-text-lg md:tw-font-condensed md:tw-italic md:tw-uppercase md:tw-text-center md:tw-flex-1"
      : "md:tw-text-base";
  textClassName += (props.which && props.which === 'flats') ? " xs:tw-leading-tight":
  " xs:tw-leading-tight md:tw-px-5 tw-px-0 tw-break-words md:tw-break-normal";
  const lang = props.lang;
  return (
    <ul className={outerClassName}>
      {props.items.map((item, index) => {
        if(props.which && props.which === 'flats') 
          item.icon = iconMapping.flatrates[item.type];
        
        return (
          <li
            className={`${innerClassName} tw-flex tw-flex-col tw-items-center tw-justify-start tw-text-center`}
            key={"flex-list_" + index}
          >
            <div
              className={`${imageOuterClassName} tw-w-12 tw-h-12 tw-bg-white tw-rounded-lg tw-flex tw-items-center tw-justify-center`}
            >
              <Icon
                icon={item.icon ?? "inklusive"}
                // size={32}
                className={`${imageInnerClassName} tw-w-8 tw-h-8`}
              />
            </div>
            <p
              className={`${textClassName} tw-text-xs tw-pt-2 tw-text-black`}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(item.title[lang] || item.title),
              }}
            ></p>
          </li>
        );
      })}
    </ul>
  );
}

export default FlexList;
